const INITIAL_STATE = {
  tryRedirect: false,
  showFilters: true
};

const SearchPreCompData = {
  INITIAL_STATE,
}

export default SearchPreCompData;